
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { useI18n } from 'vue-i18n/index';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  export default defineComponent({
    name: 'registered-accounts-widget',
    props: {
      widgetClasses: String,
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(true);
      const totalRegisteredAccounts = ref(0);
      const totalRegisteredAccountsChangePercentage = ref(0);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);

      const store = useStore();
      await store.dispatch(Actions.GET_REGISTERED_ACCOUNTS);
      const data = computed(() => store.getters.registeredAccountsDashboard);

      totalRegisteredAccounts.value =
        data.value.data.accountsSummary.totalRegisteredAccounts;

      totalRegisteredAccountsChangePercentage.value =
        data.value.data.accountsSummary.totalRegisteredAccountsChangePercentage;
      loading.value = false;
      const selectedPeriod = ref('last-7-days');

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };

      const selectPeriod = async (period: string) => {
        loading.value = true;

        selectedPeriod.value = period;
        const obj = {
          dateRange: period,
          showTrend: false,
          dateFrom: '',
          dateTo: '',
        };

        if (period === 'custom' && customDateFrom.value && customDateTo.value) {
          obj.dateFrom = customDateFrom.value;
          obj.dateTo = customDateTo.value;
        }

        await store.dispatch(Actions.GET_REGISTERED_ACCOUNTS, obj);

        totalRegisteredAccounts.value =
          data.value.data.accountsSummary.totalRegisteredAccounts;

        totalRegisteredAccountsChangePercentage.value =
          data.value.data.accountsSummary.totalRegisteredAccountsChangePercentage;
        loading.value = false;
        reinitializeComponents();
      };

      const textColor = computed(() => {
        if (totalRegisteredAccountsChangePercentage.value > 0) return '#28a745';
        if (totalRegisteredAccountsChangePercentage.value < 0) return '#dc3545';
        return '#6c757d';
      });

      const arrowSrc = computed(() => {
        if (totalRegisteredAccountsChangePercentage.value > 0)
          return '/media/icons/dash/up.png';
        if (totalRegisteredAccountsChangePercentage.value < 0)
          return '/media/icons/dash/down.png';
        return '';
      });

      return {
        textColor,
        arrowSrc,
        totalRegisteredAccounts,
        totalRegisteredAccountsChangePercentage,
        data,
        loading,
        selectedPeriod,
        selectPeriod,
        translate,
        showCustomDatePicker,
        customDateFrom,
        customDateTo,
        applyCustomDates,
        showDatePicker,
      };
    },
  });
